import { Section } from '../UI/IgmtInk'

const Settings = props => {
  return (
    <Section
      attr={{ id: 'settings' }}
      className="p-4 py-9 lg:py-24 bg-[#f9f9f9] animate-slide-down"
    >
      <div className="grid grid-cols-1 gap-12 sm:gap-14 md:gap-16">
        <div className="grid grid-cols-1 justify-items-center gap-2">
          <span className='font-["Lora"] font-bold text-lg sm:text-xl md:text-2xl'>
            JANUARY
          </span>
          <div className="flex items-center gap-4">
            <div className="border-y-[#1e1e1e] border-y-2 px-2">
              <span className='font-["Lora"] font-bold text-lg sm:text-xl md:text-2xl'>
                SUNDAY
              </span>
            </div>
            <span className='font-["Lora"] font-bold text-4xl sm:text-5xl md:text-6xl'>
              22
            </span>
            <div className="border-y-[#1e1e1e] border-y-2 px-2">
              <span className='font-["Lora"] font-bold text-lg sm:text-xl md:text-2xl'>
                10:30 AM
              </span>
            </div>
          </div>
          <span className='font-["Lora"] font-bold text-lg sm:text-xl md:text-2xl'>
            2023
          </span>
        </div>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="grid grid-cols-1 justify-items-center gap-2">
            <p className='font-["Lora"] font-bold text-xl text-blue-500 sm:text-2xl md:self-end'>
              SAN ROQUE PARISH CHURCH
            </p>
            <p className="sm:text-lg">Aguila St. Dist. I, Cuyapo Nueva Ecija</p>
          </div>
          <div className="mapouter relative text-right h-64 w-full">
            <div className="gmap_canvas overflow-hidden bg-none h-64 w-full">
              <iframe
                width="100%"
                height="256"
                id="gmap_canvas"
                src="https://maps.google.com/maps?q=San%20Roque%20Parish&t=&z=19&ie=UTF8&iwloc=&output=embed"
                frameBorder="0"
                scrolling="no"
                marginHeight="0"
                marginWidth="0"
              ></iframe>
              <a href="https://123movies-to.org"></a>
              <br />
              <a href="https://www.embedgooglemap.net">embed google map html</a>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="flex flex-col items-center gap-2 md:self-center">
            <p className="sm:text-lg">Reception to follow at</p>
            <p className='font-["Lora"] font-bold text-xl text-blue-500 sm:text-2xl'>
              DELA TORRE RESIDENCE
            </p>
            <p className="sm:text-lg">Brgy. Bentigan, Cuyapo Nueva Ecija</p>
          </div>
          <div className="mapouter relative text-right h-64 w-full">
            <div className="gmap_canvas overflow-hidden bg-none h-64 w-full">
              <iframe
                width="100%"
                height="256"
                id="gmap_canvas"
                src="https://maps.google.com/maps?q=San%20Roque%20Parish&t=&z=19&ie=UTF8&iwloc=&output=embed"
                frameBorder="0"
                scrolling="no"
                marginHeight="0"
                marginWidth="0"
              ></iframe>
              <a href="https://123movies-to.org"></a>
              <br />
              <a href="https://www.embedgooglemap.net">embed google map html</a>
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default Settings
